// Simple modal for selecting and configuring modules
import ModuleConfigForm from "./module-config-form";

class ModuleSelectorModal {
  constructor() {
    this.modal = null;
    this.selectedModuleType = null;
    this.onModuleSelected = null;
    this.showConfigForm = false;
    this.configForm = null;
  }

  show(availableModules, onSelect) {
    this.onModuleSelected = onSelect;
    this.showConfigForm = false;
    this.createModal(availableModules);
    this.modal.style.display = "block";
  }

  showConfig(moduleType, schema, onConfigSubmit, onCancel, initialConfig = {}) {
    this.showConfigForm = true;
    this.selectedModuleType = moduleType;
    // Hide the selection modal first, then create config modal
    if (this.modal) {
      this.modal.style.display = "none";
      if (this.modal.parentNode) {
        this.modal.parentNode.removeChild(this.modal);
      }
      this.modal = null;
    }
    this.createConfigModal(
      moduleType,
      schema,
      onConfigSubmit,
      onCancel,
      initialConfig
    );
    if (this.modal) {
      this.modal.style.display = "block";
    }
  }

  hide() {
    if (this.modal) {
      this.modal.style.display = "none";
      document.body.removeChild(this.modal);
      this.modal = null;
    }
  }

  createModal(availableModules) {
    // Remove existing modal if present
    const existing = document.getElementById("module-selector-modal");
    if (existing) {
      document.body.removeChild(existing);
    }

    this.modal = document.createElement("div");
    this.modal.id = "module-selector-modal";
    this.modal.style.cssText = `
      display: none;
      position: fixed;
      z-index: 10000;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.5);
    `;

    const modalContent = document.createElement("div");
    modalContent.style.cssText = `
      background-color: #fff;
      margin: 10% auto;
      padding: 20px;
      border: 1px solid #888;
      width: 80%;
      max-width: 600px;
      border-radius: 4px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;

    const header = document.createElement("div");
    header.style.cssText =
      "display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;";

    const title = document.createElement("h2");
    title.textContent = "Insert Module";
    title.style.cssText = "margin: 0;";

    const closeBtn = document.createElement("span");
    closeBtn.textContent = "×";
    closeBtn.style.cssText =
      "font-size: 28px; font-weight: bold; cursor: pointer; color: #aaa;";
    closeBtn.onclick = () => this.hide();

    header.appendChild(title);
    header.appendChild(closeBtn);

    const moduleList = document.createElement("div");
    moduleList.style.cssText =
      "display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px;";

    availableModules.forEach((module) => {
      const moduleButton = document.createElement("button");
      moduleButton.textContent = module.label || module.type;
      moduleButton.style.cssText = `
        padding: 15px;
        border: 1px solid #ddd;
        background: #f9f9f9;
        cursor: pointer;
        border-radius: 4px;
        text-align: center;
        transition: background 0.2s;
      `;
      moduleButton.onmouseover = () => {
        moduleButton.style.background = "#f0f0f0";
      };
      moduleButton.onmouseout = () => {
        moduleButton.style.background = "#f9f9f9";
      };
      moduleButton.onclick = () => {
        this.selectModule(module.type);
      };
      moduleList.appendChild(moduleButton);
    });

    modalContent.appendChild(header);
    modalContent.appendChild(moduleList);
    this.modal.appendChild(modalContent);

    // Close on backdrop click
    this.modal.onclick = (e) => {
      if (e.target === this.modal) {
        this.hide();
      }
    };

    document.body.appendChild(this.modal);
  }

  selectModule(moduleType) {
    if (this.onModuleSelected) {
      // Call the callback - it will handle showing the config modal
      // Don't hide here, let showConfig() handle it
      this.onModuleSelected(moduleType);
    }
  }

  createConfigModal(
    moduleType,
    schema,
    onConfigSubmit,
    onCancel,
    initialConfig = {}
  ) {
    // Remove existing modal if present
    const existing = document.getElementById("module-selector-modal");
    if (existing) {
      document.body.removeChild(existing);
    }

    this.modal = document.createElement("div");
    this.modal.id = "module-selector-modal";
    this.modal.style.cssText = `
      display: none;
      position: fixed;
      z-index: 10000;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.5);
    `;

    const modalContent = document.createElement("div");
    modalContent.style.cssText = `
      background-color: #fff;
      margin: 5% auto;
      padding: 0;
      border: 1px solid #888;
      width: 90%;
      max-width: 700px;
      max-height: 90vh;
      border-radius: 4px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      overflow-y: auto;
    `;

    const header = document.createElement("div");
    header.style.cssText =
      "display: flex; justify-content: space-between; align-items: center; padding: 20px; border-bottom: 1px solid #eee;";

    const title = document.createElement("h2");
    title.textContent = `Configure ${schema.label || moduleType}`;
    title.style.cssText = "margin: 0;";

    const closeBtn = document.createElement("span");
    closeBtn.textContent = "×";
    closeBtn.style.cssText =
      "font-size: 28px; font-weight: bold; cursor: pointer; color: #aaa;";
    closeBtn.onclick = () => {
      if (onCancel) onCancel();
      this.hide();
    };

    header.appendChild(title);
    header.appendChild(closeBtn);

    // Render config form with initial config (for editing)
    const formBuilder = new ModuleConfigForm(moduleType, schema, initialConfig);
    formBuilder.onSubmit = (config) => {
      if (onConfigSubmit) {
        onConfigSubmit(moduleType, config);
      }
      this.hide();
    };
    formBuilder.onCancel = () => {
      if (onCancel) onCancel();
      this.hide();
    };

    const formElement = formBuilder.render();
    modalContent.appendChild(header);
    modalContent.appendChild(formElement);

    this.modal.appendChild(modalContent);

    // Close on backdrop click
    this.modal.onclick = (e) => {
      if (e.target === this.modal) {
        if (onCancel) onCancel();
        this.hide();
      }
    };

    document.body.appendChild(this.modal);
  }
}

export default ModuleSelectorModal;
